@if (filters) {
  <!-- the above to be eventually replaced by below -->
  @for (item of filters; track item; let indx = $index) {
    @if (item.label) {
      <label class="quick-filter-label">{{item.label}}</label>
    }
    @for (filter of item.filterRow; track filter) {
      <div class="quick-filter-btn">
        <mt-btn [class]="getButtonClass(filter)" (onAction)="onFilter(filter)">
          <!-- filter btn icon if exist  -->
          @if (filter.icon) {
            <span [ngClass]="filter.icon" class="mr-5"></span>
          }
          <!-- ./filter icon  -->
          <!-- filter btn name if exist -->
          <span class="hidden-on-mobile">{{filter.name}}</span>
        </mt-btn>
      </div>
    }
  }
}
